export const ORGAN_NAMES = {
  KIDNEY: 'Kidney',
  LIVER: 'Liver',
  LUNG: 'Lung',
  PANCREAS: 'Pancreas',
  HEART: 'Heart',
  SPLEEN: 'Spleen',
};

export const SPECIES_NAMES = {
  HUMAN: 'Human',
  MOUSE: 'Mouse',
  RAT: 'Rat',
  HAMSTER: 'Hamster',
};

export const STAIN_TYPE_NAMES = {
  H_E: 'H&E',
  IHC: 'IHC',
  IF: 'IF',
  UNSTAINED: 'Unstained',
  SPECIAL: 'Special',
};

export const STAIN_TYPE_VALUES = {
  h_and_e: STAIN_TYPE_NAMES.H_E,
  ihc: STAIN_TYPE_NAMES.IHC,
  if: STAIN_TYPE_NAMES.IF,
  unstained: STAIN_TYPE_NAMES.UNSTAINED,
  special_stain: STAIN_TYPE_NAMES.SPECIAL,
};

export const SLIDE_UPLOAD_SOURCES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
};
